module.exports = __webpack_public_path__ + "static/media/pixel_2_support_list.dae6c4b2.png";